module.exports = require("babel-runtime/core-js/json/stringify");


/*****************
 ** WEBPACK FOOTER
 ** external "babel-runtime/core-js/json/stringify"
 ** module id = 0
 ** module chunks = 0
 **/